import { DealerPanelContentLabelWithIcon } from '@/components/sections/dealer/panel/content/label-with-icon';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';
import { Grid } from '@/components/shared/layout/grid';
import { IIcon } from '@/types/shared';

interface DealerPanelContentGroupDataRowLabelValueProps {
  label: string;
  labelIcon?: IIcon;
  children?: React.ReactNode;
  valueRowGap?: number;
}

export const DealerPanelContentGroupDataRowLabelValue = (
  props: DealerPanelContentGroupDataRowLabelValueProps
) => {
  return (
    <Grid
      columnGap="4"
      css={{
        color: '$gray900',
        gridTemplateColumns: '35% auto',
        '@sm': {
          columnGap: 6,
          templateColumns: 3,
        },
      }}
    >
      <Box
        css={{
          '@xs': {
            gridColumn: '1',
          },
        }}
      >
        <DealerPanelContentLabelWithIcon
          icon={props.labelIcon}
          label={props.label}
        />
      </Box>
      <Flex
        direction="column"
        css={{
          a: {
            color: '$primary',
          },
          '@xs': {
            gridColumn: '2 / span 2',
          },
        }}
        rowGap={props.valueRowGap}
      >
        {props.children}
      </Flex>
    </Grid>
  );
};

DealerPanelContentGroupDataRowLabelValue.displayName =
  'DealerPanelContentGroupDataRowLabelValue';
